import React, { useState } from 'react';
import {
  Box,
  Button,
  ButtonIcon,
  Checkbox,
  Icon,
  Typography,
} from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../utils/localization';

import { invertedMessages } from './messages';

import './CertsConsultPopover.css';

function CertsConsultContent({
  setIsCommentPopoverOpen,
  onSubmit,
  isMobileXlargeWidth,
}) {
  const l = useInvertedLocalize(invertedMessages);
  const [isChecked, setIsChecked] = useState(false);

  const handleSubmit = () => onSubmit(isChecked);

  const handleChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <Box className='CertsConsultPopover'>
      <Box className='CertsConsultPopover-content'>
        <Box className='CertsConsultPopover-header'>
          <Typography
            kind='h3'
            mobile='h2-m'
            className='CertsConsultPopover-title'>
            {l('Consultation Requested')}
          </Typography>
          {!isMobileXlargeWidth && (
            <ButtonIcon
              size='small'
              kind='ghost'
              icon={<Icon kind='Close' color='neutral-1000' />}
              onClick={() => setIsCommentPopoverOpen(false)}
            />
          )}
        </Box>
        <Typography
          kind='body2'
          mobile='body2-d'
          className='CertsConsultPopover-note'>
          {l(
            'You can wait for responses to your consultations, consult with other peers, or go ahead and make decisions. Once all decisions are made, you can review and submit your certification.'
          )}
        </Typography>
        <Box className='CertsConsultPopover-checkbox'>
          <Checkbox
            id='consult-content-checkbox'
            name='simpleText'
            dataTestId='simpleText'
            size='small'
            isChecked={isChecked}
            onChange={handleChange}
            label={
              <Typography
                kind='body3'
                mobile='body2-m'
                className='CertsConsultPopover-label'>
                {l('Don’t show this again for this certification')}
              </Typography>
            }
            textPosition='after'
            showHoverEffect
          />
        </Box>
      </Box>
      {/* Buttons */}
      <Box tag='div' className='CertsConsultPopover-controls'>
        <Button
          type='button'
          kind='filled'
          onClick={handleSubmit}
          size={isMobileXlargeWidth ? 'medium' : 'small'}>
          {l('Got it')}
        </Button>
      </Box>
    </Box>
  );
}

CertsConsultContent.defaultProps = {};

CertsConsultContent.propTypes = {
  setIsCommentPopoverOpen: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isMobileXlargeWidth: PropTypes.bool.isRequired,
};

export default CertsConsultContent;
